export const mapAndSortDetections = (acccessEventDetections, confirmedDetections, currentIdentityId, hasConfidences) => {
  let scoredDetectionIds = {}

  if (hasConfidences) {
    acccessEventDetections.forEach(detection => {
      const cotenantConfidence = detection.cotenantMatchConfidences ? detection.cotenantMatchConfidences.nn_prob : 0
      const matchConfidence = detection.matchConfidences ? detection.matchConfidences.nn_prob : 0
      detection.sortScore = cotenantConfidence > matchConfidence ? cotenantConfidence : matchConfidence
      if (cotenantConfidence > matchConfidence) {
        detection.isCotenant = true
        scoredDetectionIds[detection.detectionId] = cotenantConfidence
      } else {
        scoredDetectionIds[detection.detectionId] = matchConfidence
      }
    })
  }

  if (confirmedDetections && confirmedDetections.length > 0) {
    confirmedDetections.forEach(detection => {
      if (!detection.rejected) {
        const sortScore = detection.identity_id === currentIdentityId ? 2 : 1
        if (scoredDetectionIds[detection.detection_id]) {
          scoredDetectionIds[detection.detection_id] += sortScore
        } else {
          scoredDetectionIds[detection.detection_id] = sortScore
        }
      }
    })
  }
  acccessEventDetections.forEach(detection => {
    detection.score = scoredDetectionIds[detection.detectionId]
  })
  const hasVerifiedMatches = Object.keys(scoredDetectionIds).length > 0
  acccessEventDetections.sort((detectionA, detectionB) => {
    if (hasVerifiedMatches) {
      return scoredDetectionIds[detectionB.detectionId] - scoredDetectionIds[detectionA.detectionId]
    } else return detectionB.faceDetectorConfidence - detectionA.faceDetectorConfidence
  })
  return acccessEventDetections
}
